// Google AdSense 클라이언트 / 슬롯 ID 중앙 관리.
// 슬롯은 환경변수로 주입하여 발급 후 .env 갱신만으로 활성화.
//
// ⚠ AdSense 스크립트는 광고 충전 시 `ins.adsbygoogle` 의 **모든 조상**에 인라인
// `height: auto !important`(+ min-height 가진 조상엔 `min-height: 0 !important`)를 주입해
// 고정 높이 컨테이너를 무력화한다(JCG-2244, production DOM 관측). 새 위치에 광고를 넣을 때
// 조상에 고정 높이가 필요하면 ShellFrame 의 "스페이서 + abs(inset-0) 패널" 격리 패턴 참조
// (.claude/docs/ui-patterns/three-column-layout.md §aside 높이).

export const ADSENSE_CLIENT = "ca-pub-3876544179221586";

// env 값에 줄바꿈/공백이 섞여 들어오면(Vercel 대시보드 붙여넣기 실수 등) slotname에
// %0A가 끼어 AdSense 요청이 오염된다(JCG-2058). trim으로 방어한다.
export const ADSENSE_SLOTS = {
  // 고정 160×600 스카이스크래퍼(레거시). sidebarResponsive 가 설정되면 사용 안 함.
  sidebar: process.env.NEXT_PUBLIC_ADSENSE_SLOT_SIDEBAR?.trim(),
  // 사이드바 반응형 세로 슬롯(JCG-2194). 셸 사이드바 폭(300~680px)에 맞춰 폭을 채우고
  // 세로로 늘어나도록 responsive display ad 로 렌더한다. 대시보드에서 반응형 디스플레이
  // 슬롯으로 새로 발급 후 env(.env.production·Vercel) 갱신만으로 활성화. 미설정 시
  // AdSenseSidebar 가 레거시 sidebar 슬롯으로 폴백(코드 레벨 format 은 동일하게 반응형).
  sidebarResponsive:
    process.env.NEXT_PUBLIC_ADSENSE_SLOT_SIDEBAR_RESPONSIVE?.trim(),
  inlineProblem: process.env.NEXT_PUBLIC_ADSENSE_SLOT_INLINE_PROBLEM?.trim(),
  inlinePost: process.env.NEXT_PUBLIC_ADSENSE_SLOT_INLINE_POST?.trim(),
  aboveLikeDesktop: "7082039396",
  aboveLikeMobile: "4455876056",
  interstitial: process.env.NEXT_PUBLIC_ADSENSE_SLOT_INTERSTITIAL?.trim(),
} as const;

export const ADSENSE_SDK_URL = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${ADSENSE_CLIENT}`;

// 프로덕션 빌드가 아니거나(개발/테스트) 목업 플래그가 켜져 있으면 실제 adsbygoogle.js
// 대신 mock SDK를 설치한다. 그러면 dev에서도 실제 AdSense의 노출 동작(positional
// fill, width=0 미충전 등)이 그대로 재현되어 노출 버그를 배포 전에 확인할 수 있다(JCG-2057).
export const ADSENSE_USE_MOCK =
  process.env.NEXT_PUBLIC_SHOW_ADSENSE_MOCK === "true" ||
  process.env.NODE_ENV !== "production";
